import {useMemo} from "react";
import {GroupBase, StylesConfig, Theme} from "react-select";

interface IHook<Option = unknown, IsMulti extends boolean = boolean, Group extends GroupBase<Option> = GroupBase<Option>> {
    getTheme: (theme: Theme) => Theme;
    styles: StylesConfig<Option, IsMulti, Group>;
}

export const useSelectTheme = <Option = unknown, IsMulti extends boolean = boolean, Group extends GroupBase<Option> = GroupBase<Option>>(
    isBorderless?: boolean
): IHook<Option, IsMulti, Group> => {
    const getTheme = ({colors, spacing}: Theme): Theme => {
        return {
            colors: {
                ...colors,
                neutral20: "var(--colors-gray-600)",
                neutral30: "var(--colors-gray-600)",
                primary: "var(--colors-info)",
                primary25: "var(--colors-gray-200)"
            },
            spacing: {...spacing},
            borderRadius: 8
        };
    };

    const styles: StylesConfig<Option, IsMulti, Group> = useMemo(() => {
        return {
            control: (provided, state) => {
                return {
                    ...provided,
                    backgroundColor: state.isDisabled ? "var(--colors-gray-100)" : provided.backgroundColor,
                    borderColor: state.isDisabled ? "#a7a7ab" : provided.borderColor,
                    minHeight: "unset",
                    ["&:hover"]: {...(provided["&:hover"] as object), boxShadow: "0px 4px 10px rgba(174, 177, 180, 0.3)"},
                    ...(isBorderless ? {border: "none", boxShadow: "none !important"} : null),
                    // seems like we are using additional 1px vertical padding in InputCore. Add that to "control" to match
                    padding: `calc((1.5 * var(--globals-baseUnit)) + 1px) 0 calc((1.5 * var(--globals-baseUnit)) + 1px) calc(2 * var(--globals-baseUnit))`,
                    height: "100%"
                };
            },
            singleValue: (provided, state) => {
                return {
                    ...provided,
                    cursor: "pointer",
                    color: state.isDisabled ? "var(--colors-gray-700)" : provided.color
                };
            },
            multiValue: (provided) => {
                return {
                    ...provided,
                    margin: "0"
                };
            },
            indicatorSeparator: () => {
                return {display: "none"};
            },
            indicatorsContainer: (provided) => ({
                ...provided,
                cursor: "pointer",

                // restyle inner components to unlock field height customization
                ["div"]: {
                    height: "100%",
                    padding: "0 1rem 0 0",
                    alignContent: "center",
                    flexWrap: "wrap"
                }
            }),
            input: (provided) => ({
                ...provided,
                margin: "0",
                padding: "0",
                cursor: "text"
            }),
            menu: (provided) => {
                return {...provided, padding: "0.8rem", zIndex: 1000};
            },
            noOptionsMessage: (provided) => {
                return {...provided, color: "var(--colors-secondary)", padding: "0.8rem"};
            },
            container: (provided) => ({
                ...provided,
                width: "100%",
                maxWidth: "100%"
            }),
            option: (provided, state) => {
                return {
                    ...provided,
                    backgroundColor: state.isSelected ? "#fff" : provided.backgroundColor,
                    color: state.isSelected ? "var(--colors-secondary)" : provided.color
                };
            },
            placeholder: (provided, state) => {
                return {
                    ...provided,
                    color: state.isDisabled ? "var(--colors-gray-700)" : provided.color
                };
            },
            valueContainer: (provided) => {
                return {...provided, padding: "0", height: "100%", gap: "0.2rem"};
            },
            dropdownIndicator: (provided) => {
                return {...provided, padding: 0};
            }
        };
    }, []);

    return {
        getTheme,
        styles
    };
};
import {useMemo} from "react";
import {GroupBase, StylesConfig, Theme} from "react-select";

interface IHook<Option = unknown, IsMulti extends boolean = boolean, Group extends GroupBase<Option> = GroupBase<Option>> {
    getTheme: (theme: Theme) => Theme;
    styles: StylesConfig<Option, IsMulti, Group>;
}

export const useSelectTheme = <Option = unknown, IsMulti extends boolean = boolean, Group extends GroupBase<Option> = GroupBase<Option>>(
    isBorderless?: boolean
): IHook<Option, IsMulti, Group> => {
    const getTheme = ({colors, spacing}: Theme): Theme => {
        return {
            colors: {
                ...colors,
                neutral20: "var(--colors-gray-600)",
                neutral30: "var(--colors-gray-600)",
                primary: "var(--colors-info)",
                primary25: "var(--colors-gray-200)"
            },
            spacing: {...spacing},
            borderRadius: 8
        };
    };

    const styles: StylesConfig<Option, IsMulti, Group> = useMemo(() => {
        return {
            control: (provided, state) => {
                return {
                    ...provided,
                    backgroundColor: state.isDisabled ? "var(--colors-gray-100)" : provided.backgroundColor,
                    borderColor: state.isDisabled ? "#a7a7ab" : provided.borderColor,
                    minHeight: "unset",
                    ["&:hover"]: {...(provided["&:hover"] as object), boxShadow: "0px 4px 10px rgba(174, 177, 180, 0.3)"},
                    ...(isBorderless ? {border: "none", boxShadow: "none !important"} : null),
                    // seems like we are using additional 1px vertical padding in InputCore. Add that to "control" to match
                    padding: `calc((1.5 * var(--globals-baseUnit)) + 1px) 0 calc((1.5 * var(--globals-baseUnit)) + 1px) calc(2 * var(--globals-baseUnit))`,
                    height: "100%"
                };
            },
            singleValue: (provided, state) => {
                return {
                    ...provided,
                    cursor: "pointer",
                    color: state.isDisabled ? "var(--colors-gray-700)" : provided.color
                };
            },
            multiValue: (provided) => {
                return {
                    ...provided,
                    margin: "0"
                };
            },
            indicatorSeparator: () => {
                return {display: "none"};
            },
            indicatorsContainer: (provided) => ({
                ...provided,
                cursor: "pointer",

                // restyle inner components to unlock field height customization
                ["div"]: {
                    height: "100%",
                    padding: "0 1rem 0 0",
                    alignContent: "center",
                    flexWrap: "wrap"
                }
            }),
            input: (provided) => ({
                ...provided,
                margin: "0",
                padding: "0",
                cursor: "text"
            }),
            menu: (provided) => {
                return {...provided, padding: "0.8rem", zIndex: 1000};
            },
            noOptionsMessage: (provided) => {
                return {...provided, color: "var(--colors-secondary)", padding: "0.8rem"};
            },
            container: (provided) => ({
                ...provided,
                width: "100%",
                maxWidth: "100%"
            }),
            option: (provided, state) => {
                return {
                    ...provided,
                    backgroundColor: state.isSelected ? "#fff" : provided.backgroundColor,
                    color: state.isSelected ? "var(--colors-secondary)" : provided.color
                };
            },
            placeholder: (provided, state) => {
                return {
                    ...provided,
                    color: state.isDisabled ? "var(--colors-gray-700)" : provided.color
                };
            },
            valueContainer: (provided) => {
                return {...provided, padding: "0", height: "100%", gap: "0.2rem"};
            },
            dropdownIndicator: (provided) => {
                return {...provided, padding: 0};
            }
        };
    }, []);

    return {
        getTheme,
        styles
    };
};
